;(() => {
  if (window.__sai_kpzzjf3o_initialized__) return
  window.__sai_kpzzjf3o_initialized__ = true

  const SNIPPET_ID = 'kpzzjf3o'
  const TAG = 'sai-kpzzjf3o'
  const CLS = 'sai-kpzzjf3o'
  const FEATURE_SLUG = 'product_reviews_form'

  function noopTrack() {}
  function safeTrack(track) {
    return (name, payload) => {
      try {
        track(name, payload)
      } catch (_) {
        /* analytics is best-effort */
      }
    }
  }

  const DEFAULTS = {
    form_layout: 'inline',
    show_product_image: true,
    show_product_name: true,
    star_size: 'medium',
    star_color_filled: '#E0A84B',
    star_color_empty: '#D1D5DB',
    rating_label: '',
    title_placeholder: 'Title',
    title_max_chars: 200,
    body_placeholder: 'Description',
    body_max_chars: 5000,
    body_min_chars: 1,
    allow_image_upload: true,
    allow_video_upload: true,
    max_files: 5,
    max_file_size_mb: 20,
    confirmation_message: 'Thank you for your review!',
    show_confirmation_animation: true,
  }

  const STAR_SIZES = { small: 20, medium: 28, large: 36 }

  // ---- Utilities ----

  function esc(s) {
    if (!s) return ''
    const d = document.createElement('div')
    d.textContent = String(s)
    return d.innerHTML
  }

  function g(props, key) {
    const v = props?.[key]
    return v !== undefined && v !== null && v !== '' ? v : DEFAULTS[key]
  }

  function starSvg(size, fill, stroke) {
    return `<svg width="${size}" height="${size}" viewBox="0 0 24 24" fill="${fill}" stroke="${stroke}" stroke-width="1.5" stroke-linejoin="round"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>`
  }

  function cameraSvg() {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>'
  }

  function closeSvg() {
    return '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  }

  function checkSvg() {
    return '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>'
  }

  function modalCloseSvg() {
    return '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
  }

  function resolveProduct(poolProduct) {
    if (poolProduct?.handle) return poolProduct
    const params = new URLSearchParams(window.location.search)
    const handle = params.get('product') || params.get('product_handle')
    if (handle) return { handle: handle, title: null, imageUrl: null }
    return poolProduct || null
  }

  // ---- Pool reader ----

  function readSnippetPool(node) {
    for (let i = 0; i < node.children.length; i++) {
      const child = node.children[i]
      if (child.tagName === 'SCRIPT' && child.hasAttribute('data-spectrum-snippet-pool')) {
        const text = child.textContent
        if (!text) return {}
        try {
          return JSON.parse(text)
        } catch (_) {
          return {}
        }
      }
    }
    return {}
  }

  // ---- Custom Element ----

  class SaiReviewForm extends HTMLElement {
    constructor() {
      super()
      this._rating = 0
      this._hoverRating = 0
      this._files = []
      this._submitting = false
      this._props = {}
      this._product = null
      this._formRoot = null
      this._bound = false
      this._track = noopTrack
    }

    connectedCallback() {
      // Initialized via bind callback, not here
    }

    setAnalytics(track) {
      this._track = typeof track === 'function' ? safeTrack(track) : noopTrack
    }

    applyVariant(presentation) {
      if (!presentation) return
      this._props = presentation
      const layout = g(presentation, 'form_layout')
      if (layout === 'modal' && !this._modalBound) this._initModal()
      if (this._formRoot) {
        this._formRoot.innerHTML = ''
        this._renderForm()
      }
      this._maybeLoadProduct()
    }

    init(props, pool) {
      if (this._bound) return
      this._bound = true
      this._props = props || {}
      this._product = resolveProduct(pool?.product)
      this._formRoot = this.querySelector('[data-form-root]')

      const layout = g(this._props, 'form_layout')

      if (layout === 'modal') {
        this._initModal()
      }

      if (this._formRoot) {
        this._formRoot.innerHTML = ''
        this._renderForm()
      }

      this._maybeLoadProduct()
    }

    _maybeLoadProduct() {
      const hasSsrProduct = !!this.querySelector('[data-product-meta]')
      if (hasSsrProduct || !this._product?.handle) return
      if (!window.Spectrum?.products?.getByHandle) return

      const p = this._props
      const showImg = g(p, 'show_product_image')
      const showName = g(p, 'show_product_name')
      if (!showImg && !showName) return

      window.Spectrum.products
        .getByHandle(this._product.handle)
        .then((data) => {
          if (!data) return
          // Shopify AJAX API doesn't expose featured_media; media[0] matches its ordering.
          const imgUrl = data.featured_image || data.media?.[0]?.preview_image?.src || null
          this._product.title = data.title
          this._product.imageUrl = imgUrl
          const container = this.querySelector('[data-form-root]')?.parentElement
          if (!container) return
          const existing = container.querySelector('[data-product-meta]')
          if (existing) return
          let html = `<div class="${CLS}__product" data-product-meta>`
          if (showImg && imgUrl) {
            html += `<img src="${imgUrl}" alt="" class="${CLS}__product-image" width="160" height="160" loading="lazy" />`
          }
          if (showName && data.title) {
            html += `<p class="${CLS}__product-name">${data.title}</p>`
          }
          html += '</div>'
          const formRoot = container.querySelector('[data-form-root]')
          if (formRoot) formRoot.insertAdjacentHTML('beforebegin', html)
        })
        .catch(() => {})
    }

    _initModal() {
      if (this._modalBound) return
      this._modalBound = true
      const trigger = this.previousElementSibling
      if (trigger?.hasAttribute('data-rvw-trigger')) {
        trigger.addEventListener('click', () => {
          this.classList.add(`${CLS}--modal-open`)
          document.body.style.overflow = 'hidden'
        })
      }

      // Wrap all content in a modal body card
      const body = document.createElement('div')
      body.className = `${CLS}__modal-body`
      while (this.firstChild) body.appendChild(this.firstChild)
      this.appendChild(body)

      const closeBtn = document.createElement('button')
      closeBtn.type = 'button'
      closeBtn.className = `${CLS}__modal-close`
      closeBtn.innerHTML = modalCloseSvg()
      closeBtn.addEventListener('click', () => this._closeModal())
      body.prepend(closeBtn)

      this.addEventListener('click', (e) => {
        if (e.target === this) this._closeModal()
      })
    }

    _closeModal() {
      this.classList.remove(`${CLS}--modal-open`)
      document.body.style.overflow = ''
    }

    _renderForm() {
      const p = this._props
      const root = this._formRoot
      let html = ''

      // Star rating
      html += this._buildStarRating()

      // Name field (always required by API)
      html += this._buildField(
        'Full Name',
        true,
        `<input type="text" class="${CLS}__input" data-field="name" placeholder="Your name" required />`,
        'name',
      )

      // Title
      html += this._buildField(
        'Review Title',
        false,
        `<input type="text" class="${CLS}__input" data-field="title" placeholder="${esc(g(p, 'title_placeholder'))}" maxlength="${g(p, 'title_max_chars')}" />`,
      )

      // Body (always required by API)
      html += this._buildField(
        'Review',
        true,
        `<textarea class="${CLS}__textarea" data-field="body" placeholder="${esc(g(p, 'body_placeholder'))}" maxlength="${g(p, 'body_max_chars')}" required></textarea>`,
        'body',
      )

      // Media upload
      if (g(p, 'allow_image_upload') || g(p, 'allow_video_upload')) {
        html += this._buildField(
          'Photos / Videos',
          false,
          `<div class="${CLS}__media-upload"><div class="${CLS}__media-items" data-media-items></div><label class="${CLS}__upload-btn">${cameraSvg()}<input type="file" class="${CLS}__file-input" data-file-input multiple accept="${this._acceptTypes()}" /></label></div><p class="${CLS}__media-hint">Max ${g(p, 'max_file_size_mb')} MB per file</p>`,
          'media',
        )
      }

      // Email field (always required by API)
      html += this._buildField(
        'Email',
        true,
        `<input type="email" class="${CLS}__input" data-field="email" placeholder="Your email" required />`,
        'email',
      )

      // Error area
      html += `<div class="${CLS}__error" data-error style="display:none"></div>`

      // Submit
      html += `<button type="button" class="${CLS}__submit" data-submit><span data-submit-text>Submit</span><span data-submit-spinner class="${CLS}__spinner" style="display:none"></span></button>`

      root.innerHTML = html
      this._prefill()
      this._listen()
    }

    _buildStarRating() {
      const p = this._props
      const size = STAR_SIZES[g(p, 'star_size')] || STAR_SIZES.medium
      const emptyColor = g(p, 'star_color_empty')
      const label = g(p, 'rating_label')
      let stars = ''
      for (let i = 1; i <= 5; i++) {
        stars += `<button type="button" class="${CLS}__star" data-star="${i}" aria-label="Rate ${i} star${i > 1 ? 's' : ''}">${starSvg(size, 'none', emptyColor)}</button>`
      }
      return `<div class="${CLS}__rating" data-star-rating>${label ? `<label class="${CLS}__rating-label">${esc(label)}</label>` : ''}<div class="${CLS}__stars" data-stars>${stars}</div><div class="${CLS}__rating-error" data-rating-error style="display:none">Please select a rating</div></div>`
    }

    _buildField(label, required, content, fieldName) {
      const errorEl = fieldName
        ? `<div class="${CLS}__field-error" data-field-error="${fieldName}" style="display:none"></div>`
        : ''
      return `<div class="${CLS}__field"><label class="${CLS}__label">${esc(label)}${required ? `<span class="${CLS}__req">*</span>` : ''}</label>${content}${errorEl}</div>`
    }

    _acceptTypes() {
      const p = this._props
      const types = []
      if (g(p, 'allow_image_upload'))
        types.push('image/jpeg', 'image/png', 'image/webp', 'image/gif')
      if (g(p, 'allow_video_upload')) types.push('video/mp4', 'video/quicktime', 'video/webm')
      return types.join(',')
    }

    _prefill() {
      const customer = window.__spectrumAi?.customer
      if (!customer) return
      const nameInput = this._formRoot?.querySelector('[data-field="name"]')
      const emailInput = this._formRoot?.querySelector('[data-field="email"]')
      if (nameInput && customer.firstName) {
        nameInput.value = [customer.firstName, customer.lastName].filter(Boolean).join(' ')
      }
      if (emailInput && customer.email) {
        emailInput.value = customer.email
      }
    }

    _listen() {
      const root = this._formRoot

      // Stars
      for (const star of root.querySelectorAll('[data-star]')) {
        star.addEventListener('click', () => {
          this._setRating(Number.parseInt(star.dataset.star))
        })
        star.addEventListener('mouseenter', () => {
          this._hoverStar(Number.parseInt(star.dataset.star))
        })
        star.addEventListener('mouseleave', () => {
          this._hoverStar(0)
        })
      }

      // Clear inline errors on input
      for (const input of root.querySelectorAll('[data-field]')) {
        const fieldName = input.dataset.field
        input.addEventListener('input', () => {
          this._clearFieldError(fieldName)
        })
      }

      // File input
      const fileInput = root.querySelector('[data-file-input]')
      if (fileInput) {
        fileInput.addEventListener('change', (e) => {
          this._handleFiles(e.target.files)
          e.target.value = ''
        })
      }

      // Submit
      const submitBtn = root.querySelector('[data-submit]')
      if (submitBtn) {
        submitBtn.addEventListener('click', () => {
          this._submit()
        })
      }
    }

    _setRating(rating) {
      this._rating = rating
      this._updateStars()
      const err = this._formRoot?.querySelector('[data-rating-error]')
      if (err) err.style.display = 'none'
      this._track(`${FEATURE_SLUG}:star_select`, { rating: rating })
    }

    _hoverStar(rating) {
      this._hoverRating = rating
      this._updateStars()
    }

    _updateStars() {
      const p = this._props
      const size = STAR_SIZES[g(p, 'star_size')] || STAR_SIZES.medium
      const filledColor = g(p, 'star_color_filled')
      const emptyColor = g(p, 'star_color_empty')
      const active = this._hoverRating || this._rating

      for (const star of this._formRoot?.querySelectorAll('[data-star]') ?? []) {
        const i = Number.parseInt(star.dataset.star)
        const filled = i <= active
        star.innerHTML = starSvg(
          size,
          filled ? filledColor : 'none',
          filled ? filledColor : emptyColor,
        )
        star.classList.toggle(`${CLS}__star--filled`, filled)
      }
    }

    _handleFiles(fileList) {
      const p = this._props
      const maxFiles = Math.min(g(p, 'max_files'), 5)
      const maxBytes = g(p, 'max_file_size_mb') * 1024 * 1024

      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        if (this._files.length >= maxFiles) {
          this._showFieldError('media', `Maximum ${maxFiles} files allowed`)
          break
        }
        if (file.size > maxBytes) {
          this._showFieldError('media', `${file.name} exceeds ${g(p, 'max_file_size_mb')} MB limit`)
          continue
        }
        const entry = { file: file, preview: null, uploaded: false, mediaData: null }
        if (file.type.startsWith('image/')) {
          entry.preview = URL.createObjectURL(file)
        }
        this._files.push(entry)
        this._track(`${FEATURE_SLUG}:media_add`, {
          file_count: this._files.length,
          media_type: file.type.startsWith('image/') ? 'image' : 'video',
        })
      }
      this._renderMedia()
    }

    _renderMedia() {
      const container = this._formRoot?.querySelector('[data-media-items]')
      if (!container) return
      container.innerHTML = ''

      for (let idx = 0; idx < this._files.length; idx++) {
        const entry = this._files[idx]
        const item = document.createElement('div')
        item.className = `${CLS}__media-item`
        if (entry.preview) {
          item.innerHTML = `<img src="${entry.preview}" class="${CLS}__media-thumb" alt="" /><button type="button" class="${CLS}__media-remove" data-rm="${idx}">${closeSvg()}</button>`
        } else {
          const name = entry.file.name
          const short = name.length > 12 ? `${name.slice(0, 5)}...${name.slice(-4)}` : name
          item.innerHTML = `<div class="${CLS}__media-file"><span>${esc(short)}</span></div><button type="button" class="${CLS}__media-remove" data-rm="${idx}">${closeSvg()}</button>`
        }
        container.appendChild(item)
      }

      for (const btn of container.querySelectorAll('[data-rm]')) {
        btn.addEventListener('click', () => {
          const idx = Number.parseInt(btn.dataset.rm)
          if (this._files[idx]?.preview) URL.revokeObjectURL(this._files[idx].preview)
          this._files.splice(idx, 1)
          this._renderMedia()
        })
      }
    }

    _showFieldError(fieldName, msg) {
      const el = this._formRoot?.querySelector(`[data-field-error="${fieldName}"]`)
      if (!el) return
      el.textContent = msg
      el.style.display = 'block'
      const input = this._formRoot?.querySelector(`[data-field="${fieldName}"]`)
      if (input) input.classList.add(`${CLS}__input--error`)
    }

    _clearFieldError(fieldName) {
      const el = this._formRoot?.querySelector(`[data-field-error="${fieldName}"]`)
      if (el) {
        el.textContent = ''
        el.style.display = 'none'
      }
      const input = this._formRoot?.querySelector(`[data-field="${fieldName}"]`)
      if (input) input.classList.remove(`${CLS}__input--error`)
    }

    _clearAllFieldErrors() {
      for (const el of this._formRoot?.querySelectorAll('[data-field-error]') ?? []) {
        el.textContent = ''
        el.style.display = 'none'
      }
      for (const el of this._formRoot?.querySelectorAll(`.${CLS}__input--error`) ?? []) {
        el.classList.remove(`${CLS}__input--error`)
      }
      const ratingErr = this._formRoot?.querySelector('[data-rating-error]')
      if (ratingErr) ratingErr.style.display = 'none'
    }

    _showError(msg) {
      const el = this._formRoot?.querySelector('[data-error]')
      if (!el) return
      el.textContent = msg
      el.style.display = 'block'
      setTimeout(() => {
        el.style.display = 'none'
      }, 5000)
    }

    _showToast(msg) {
      const existing = document.querySelector(`.${CLS}__toast`)
      if (existing) existing.remove()
      const toast = document.createElement('div')
      toast.className = `${CLS}__toast`
      toast.textContent = msg
      document.body.appendChild(toast)
      requestAnimationFrame(() => {
        toast.classList.add(`${CLS}__toast--visible`)
      })
      setTimeout(() => {
        toast.classList.remove(`${CLS}__toast--visible`)
        setTimeout(() => {
          toast.remove()
        }, 300)
      }, 4000)
    }

    async _submit() {
      if (this._submitting) return
      const p = this._props

      this._clearAllFieldErrors()

      const nameInput = this._formRoot?.querySelector('[data-field="name"]')
      const emailInput = this._formRoot?.querySelector('[data-field="email"]')
      const titleInput = this._formRoot?.querySelector('[data-field="title"]')
      const bodyInput = this._formRoot?.querySelector('[data-field="body"]')

      const name = nameInput?.value?.trim() || ''
      const email = emailInput?.value?.trim() || ''
      const title = titleInput?.value?.trim() || ''
      const body = bodyInput?.value?.trim() || ''

      let hasError = false

      // Validate rating
      if (this._rating === 0) {
        const ratingErr = this._formRoot?.querySelector('[data-rating-error]')
        if (ratingErr) ratingErr.style.display = 'block'
        hasError = true
      }

      // Field validation — name and email are always required by API
      if (!name) {
        this._showFieldError('name', 'Name is required')
        hasError = true
      }

      const minChars = Math.max(g(p, 'body_min_chars'), 1)
      if (body.length < minChars) {
        this._showFieldError(
          'body',
          minChars === 1 ? 'Review is required' : `Review must be at least ${minChars} characters`,
        )
        hasError = true
      }

      if (!email) {
        this._showFieldError('email', 'Email is required')
        hasError = true
      }

      if (hasError) {
        const firstErr = this._formRoot?.querySelector(
          '[data-rating-error][style*="block"], [data-field-error][style*="block"]',
        )
        const errField = firstErr?.closest(`.${CLS}__field`) || firstErr?.closest(`.${CLS}__rating`)
        if (errField) errField.scrollIntoView({ behavior: 'smooth', block: 'center' })
        return
      }

      const authorName = name
      const authorEmail = email

      if (!window.Spectrum?.reviews) {
        this._showError('Review submission is not available')
        return
      }

      const productHandle = this._product?.handle
      if (!productHandle) {
        this._showToast('Could not identify the product. Please try again from the product page.')
        return
      }

      this._setSubmitting(true)

      try {
        // Upload media files
        const mediaItems = []
        for (let i = 0; i < this._files.length; i++) {
          const entry = this._files[i]
          if (!entry.uploaded) {
            const uploadResult = await window.Spectrum.reviews.uploadMedia(entry.file)
            if (!uploadResult.ok) {
              this._showError(uploadResult.error?.message || 'Failed to upload file')
              this._setSubmitting(false)
              return
            }
            entry.uploaded = true
            entry.mediaData = uploadResult.data?.data ?? uploadResult.data
          }
          if (entry.mediaData) {
            mediaItems.push({
              mediaUrl: entry.mediaData.mediaUrl,
              originalFileName: entry.mediaData.originalFileName,
              fileSizeBytes: entry.mediaData.fileSizeBytes,
              mimeType: entry.mediaData.mimeType,
              mediaType: entry.mediaData.mediaType,
            })
          }
        }

        // Build review payload
        const reviewData = {
          productHandle: productHandle,
          rating: this._rating,
          authorName: authorName,
          authorEmail: authorEmail,
        }
        if (title) reviewData.title = title
        if (body) reviewData.body = body
        if (mediaItems.length > 0) reviewData.media = mediaItems

        this._track(`${FEATURE_SLUG}:submit`, {
          rating: this._rating,
          has_media: mediaItems.length > 0,
          media_count: mediaItems.length,
        })

        const result = await window.Spectrum.reviews.submitReview(reviewData)
        if (!result.ok) {
          this._track(`${FEATURE_SLUG}:submit_error`, { error: result.error?.message || 'unknown' })
          this._showError(result.error?.message || 'Failed to submit review')
          this._setSubmitting(false)
          return
        }

        this._track(`${FEATURE_SLUG}:submit_success`, { rating: this._rating })
        // Clear the loading state before the confirmation overlay covers the form,
        // otherwise the submit spinner keeps spinning behind the modal.
        this._setSubmitting(false)
        this._showConfirmation()
      } catch (err) {
        this._track(`${FEATURE_SLUG}:submit_error`, { error: 'unexpected' })
        this._showError('An unexpected error occurred. Please try again.')
        this._setSubmitting(false)
      }
    }

    _setSubmitting(submitting) {
      this._submitting = submitting
      const btn = this._formRoot?.querySelector('[data-submit]')
      const text = btn?.querySelector('[data-submit-text]')
      const spinner = btn?.querySelector('[data-submit-spinner]')
      if (btn) btn.disabled = submitting
      if (text) text.style.display = submitting ? 'none' : 'inline'
      if (spinner) spinner.style.display = submitting ? 'inline-block' : 'none'
    }

    _showConfirmation() {
      const p = this._props
      const message = g(p, 'confirmation_message')
      const showAnim = g(p, 'show_confirmation_animation')
      const layout = g(p, 'form_layout')

      const overlay = document.createElement('div')
      overlay.className = `${CLS}__confirmation`
      overlay.innerHTML = `<div class="${CLS}__confirmation-card">${showAnim ? `<div class="${CLS}__confirmation-icon">${checkSvg()}</div>` : ''}<p class="${CLS}__confirmation-msg">${esc(message)}</p><button type="button" class="${CLS}__confirmation-done">Done</button></div>`

      document.body.appendChild(overlay)
      requestAnimationFrame(() => {
        overlay.classList.add(`${CLS}__confirmation--visible`)
      })

      overlay.querySelector(`.${CLS}__confirmation-done`)?.addEventListener('click', () => {
        // The form is reached from a product page (via ?product=), so acknowledging
        // returns the shopper to that PDP. Use replace() rather than assigning href
        // so the already-submitted review page is dropped from history — otherwise
        // pressing Back on the PDP lands the shopper back on the form. Fall back to
        // an in-place reset only when no product handle is known.
        const handle = this._product?.handle
        if (handle) {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'
          window.location.replace(`${root}products/${handle}`)
          return
        }
        overlay.remove()
        this._reset()
        if (layout === 'modal') this._closeModal()
      })
    }

    _reset() {
      this._rating = 0
      this._hoverRating = 0
      for (const f of this._files) {
        if (f.preview) URL.revokeObjectURL(f.preview)
      }
      this._files = []
      this._submitting = false
      if (this._formRoot) {
        this._formRoot.innerHTML = ''
        this._renderForm()
      }
    }
  }

  if (!customElements.get(TAG)) {
    customElements.define(TAG, SaiReviewForm)
  }

  if (typeof globalThis !== 'undefined' && globalThis.__SAI_TEST_HARNESS__ === true) {
    globalThis.__saiKpzzjf3o = {
      esc,
      g,
      starSvg,
      safeTrack,
      resolveProduct,
      readSnippetPool,
    }
  }

  // ---- Bind ----

  function bindAllContainers() {
    const snippetApi = window.__spectrumAi?.snippet
    const containers = document.querySelectorAll(
      `[data-spectrum-instance-id][data-spectrum-snippet-id="${SNIPPET_ID}"]`,
    )

    if (!snippetApi?.bind) {
      for (const wrapper of containers) {
        const root = wrapper.querySelector(TAG)
        if (root) {
          const pool = readSnippetPool(wrapper)
          root.init({}, pool)
        }
      }
      return
    }

    for (const wrapper of containers) {
      const pool = readSnippetPool(wrapper)
      const root = wrapper.querySelector(TAG)
      if (!root) continue
      root.init({}, pool)
      const handles = snippetApi.bind(wrapper, ({ variant, variants, currentVariantId }) => {
        const resolved = variant ?? variants?.find((v) => v.variantId === currentVariantId)
        if (!resolved?.content) return
        const el = wrapper.querySelector(TAG)
        if (!el) return
        if (!el._bound) {
          el.init(resolved.content, readSnippetPool(wrapper))
        } else {
          el.applyVariant(resolved.content)
        }
      })
      if (handles) root.setAnalytics(handles.track)
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAllContainers, { once: true })
  } else {
    bindAllContainers()
  }
})()
